<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心</el-breadcrumb-item
        >
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/mainContent/article' }"
          >专题文章</el-breadcrumb-item
        >
        <el-breadcrumb-item
          ><span class="text-primary">编辑文章</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>

    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">编辑文章</span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form
          class="font-weight-bold"
          :model="articleInfo"
          label-width="120px"
        >
          <el-form-item label="文章标题">
            <el-input v-model="articleInfo.articleTitle"></el-input>
          </el-form-item>
          <el-form-item label="文章内容" class="m-0"></el-form-item>
          <el-form-item label-width="0">
            <my-editor v-model="articleInfo.articleContent"></my-editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitArticleForm(articleInfo)"
              >立即修改</el-button
            >
            <el-button @click="getArticleById()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import MyEditor from "../../components/common/MyEditor";
export default {
  name: "ArticleForm",
  data() {
    return {
      articleId: this.$route.params.articleId,
      articleInfo: {}
    };
  },
  components: {
    MyEditor
  },
  mounted() {
    this.getArticleById();
  },
  methods: {
    getArticleById() {
      this.axios
        .get("/article/getArticleById", {
          params: {
            articleId: this.articleId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.articleInfo = resp.data.data;
          }
        });
    },
    submitArticleForm(articleInfo) {
      this.axios
        .put("/article/admin/updateArticle", {
          articleId: articleInfo.articleId,
          articleTitle: articleInfo.articleTitle,
          articleContent: articleInfo.articleContent
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "Article" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
